/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum TABLE_ATTRS_LIST {
  NAME = "name",
  TYPE = "type",
  IDENTIFIER = "identifier",
  DESCRIPTION = "description",
}
